module.exports = "<a class=\"form-link\" [routerLink]=\"routerLink\">{{ text }}</a>";